import React, {
  forwardRef,
  Children,
  isValidElement,
  cloneElement,
} from 'react'
import { StackProps } from './Stack.types'
import Flex from '../Flex/Flex'

const Stack = forwardRef<HTMLDivElement, StackProps>(
  (
    { children, direction = 'vertical', spacing = 16, divider, gap, ...props },
    ref
  ) => {
    const flexDirection = direction === 'horizontal' ? 'row' : 'column'
    const finalGap = gap ?? spacing

    if (!divider) {
      return (
        <Flex ref={ref} direction={flexDirection} gap={finalGap} {...props}>
          {children}
        </Flex>
      )
    }

    const childrenArray = Children.toArray(children).filter(isValidElement)
    const childrenWithDividers = childrenArray.reduce<React.ReactNode[]>(
      (acc, child, index) => {
        if (index === 0) return [child]

        const dividerElement = isValidElement(divider) ? (
          cloneElement(divider, { key: `divider-${index}` })
        ) : (
          <span key={`divider-${index}`}>{divider}</span>
        )

        return [...acc, dividerElement, child]
      },
      []
    )

    return (
      <Flex ref={ref} direction={flexDirection} gap={finalGap} {...props}>
        {childrenWithDividers}
      </Flex>
    )
  }
)

Stack.displayName = 'Stack'

export default Stack
